console.log('DEBUG: custom-product-material.js script started loading.');

// Wait for the HTML content to be fully loaded before running the script
document.addEventListener('DOMContentLoaded', () => {
   console.log('DEBUG: DOMContentLoaded event fired.');

  // --- Material Mapping (Product Handle => { default: 'Material', variantId: 'Material' }) ---
  // Ensure product handles and variant IDs match exactly what Shopify uses.
  const productMaterialMap = {
    'landscape-necklace-moon-mountain': { default: 'STERLING SILVER' },
    'copy-of-friendship-rings-set-of-3-silver': { default: 'STERLING SILVER' },
    'handy-huggie-hoops': {
      default: 'STAINLESS STEEL', // Default for when no specific variant matches or on initial load without variant ID
      '45281149649191': 'STAINLESS STEEL', // Note: Corrected ID from original prompt example if needed
      '45281149681939': 'GOLD PLATED STAINLESS STEEL'
    },
    'handy-huggie-hoops-small': {
      default: 'STAINLESS STEEL',
      '48398702248211': 'STAINLESS STEEL',
      '48398702280979': 'GOLD PLATED STAINLESS STEEL'
    },
    'handy-huggie-hoops-small-copy': {
      default: 'STAINLESS STEEL',
      '50307523707155': 'STAINLESS STEEL',
      '50307523739923': 'GOLD PLATED STAINLESS STEEL'
    },
    'circle-of-life-necklace-silver-gold': {
      default: 'GOLD', // This should match the material of the default selected variant
      '20604738306110': 'GOLD',
      '20604738404414': 'STERLING SILVER'
    },
    'cascade-necklace': {
      default: 'GOLD', // This should match the material of the default selected variant
      '20604744368190': 'GOLD',
      '20604744433726': 'STERLING SILVER'
    }
    // Add any other products and their variants from your original Convert list if needed
    // Example: 'other-product-handle': { default: 'DEFAULT MATERIAL', 'variantId1': 'MATERIAL 1', 'variantId2': 'MATERIAL 2'}
  };

  // Find the container we added in product-info.liquid
  const subtitleContainer = document.querySelector('.product-material-subtitle');

  // Exit if the subtitle container doesn't exist on this page
  if (!subtitleContainer) {
    // console.log('Material subtitle container not found on this page.'); // Optional debug log
    return;
  }

  // Get the product handle from the container's data attribute
  const productHandle = subtitleContainer.getAttribute('data-product-handle');

  // Check if this product handle exists in our map
  if (!productMaterialMap.hasOwnProperty(productHandle)) {
     // console.log(`Product handle "${productHandle}" not found in material map.`); // Optional debug log
     subtitleContainer.style.visibility = 'hidden'; // Ensure it stays hidden
     return;
  }

  // --- Function to Update Subtitle ---
// MODIFIED: Accepts variantId (string or null) directly
function updateMaterialSubtitle(variantId) { // Changed parameter name
  const currentSubtitleContainer = document.querySelector('.product-material-subtitle');
  if (!currentSubtitleContainer) return;

  let materialText = '';
  const mapping = productMaterialMap[productHandle];

  if (mapping) {
    // Use the passed variantId string (or null if no ID/default)
    if (variantId && mapping.hasOwnProperty(variantId)) {
      // Specific material found for this variant ID string
      materialText = mapping[variantId];
    } else {
      // No specific variant ID match OR variantId is null, use the default
      materialText = mapping.default || ''; // Fallback to default
      // console.log(`DEBUG: Using default material for ${productHandle} (Variant ID: ${variantId || 'none'})`);
    }
  }

  // Update the text content and make visible
  if (materialText) {
      currentSubtitleContainer.textContent = materialText.toUpperCase();
      currentSubtitleContainer.style.visibility = 'visible';
  } else {
      currentSubtitleContainer.textContent = '';
      currentSubtitleContainer.style.visibility = 'hidden';
  }
}

  // --- Event Listener for Variant Changes ---
// Focal Theme Investigation: Listen for clicks within the product info area
// and check if the clicked element relates to variant selection.

// Find a container element that holds the variant selectors. Inspect your HTML structure.
// '.product__info' is a good candidate based on snippets/product-info.liquid. Adjust if needed.
const productInfoContainer = document.querySelector('.product__info');

if (productInfoContainer) {
  productInfoContainer.addEventListener('click', (event) => {
    const clickedElement = event.target;
    console.log('DEBUG: Click detected inside product info. Clicked element:', clickedElement);

    // --- Check if the click was on a variant selector ---
    // Inspect the HTML of your variant swatches/buttons. They might be:
    // - <input type="radio"> (check closest label or parent)
    // - <button> elements within a fieldset
    // - <a> tags or <div> tags acting as buttons
    // Look for common patterns like 'data-value', 'name="id"', or specific classes.

    // Example Check 1: Is it an input (radio/checkbox) or inside a label for one?
    const variantInput = clickedElement.closest('input[name="id"], label'); // Check if click is on input or its label

    // Example Check 2: Does it have a data attribute commonly used for variant values?
    const variantValueElement = clickedElement.closest('[data-value]'); // Check if click is on element with data-value

    // Example Check 3: Is it a button within a known variant block? (Adapt selector)
    const variantButton = clickedElement.closest('.product-form__option .product-form__option-value button, .variant-picker__option .variant-picker__option-value button'); // Common theme patterns


    // --- If a relevant element was clicked ---
    // Combine checks (adjust based on your theme's HTML structure)
    let isVariantClick = variantInput || variantValueElement || variantButton;
    // More specific check if needed: if(variantInput && variantInput.querySelector('input[name="id"]')) { isVariantClick = true } etc.


    if (isVariantClick) {
      console.log('DEBUG: Click likely related to variant selection:', clickedElement);

      // We need the selected variant ID. Since the click itself might not update the form
      // state immediately, we use a small delay (setTimeout) to allow the theme's
      // JS to update the hidden input/form state before we read it.
      setTimeout(() => {
        const productForm = document.querySelector('product-form, form[action="/cart/add"]');
        if (!productForm) {
            console.log('DEBUG: Product form not found inside timeout.');
            return;
        }

        const formData = new FormData(productForm);
        const selectedVariantId = formData.get('id'); // Get the CURRENT value after the click

        console.log('DEBUG: Selected Variant ID from form data (after click timeout):', selectedVariantId);

        if (selectedVariantId) {
          // Now, get the full variant object from our cached data
           console.log('DEBUG: Calling updateMaterialSubtitle with ID:', selectedVariantId);
          // Directly pass the ID string (or null if none found) to the updated function
          updateMaterialSubtitle(selectedVariantId || null);
          
        } else {
            console.log('DEBUG: Could not read selectedVariantId from FormData after click.');
        }
      }, 50); // 50ms delay - adjust if needed, usually enough

    } else {
        // console.log('DEBUG: Click was not identified as a variant selection click.'); // Optional: Log clicks not related
    }
  });

} else {
  console.error('Could not find product info container (.product__info) to attach click listener.');
}


  // --- Initial Update on Page Load ---
  // We need to get the currently selected variant when the page first loads.
  // Themes often store product data in a JSON script tag. Inspect your page source
  // for <script type="application/json" data-product-json> or similar.
  let initialVariant = null;
  try {
    // Common selectors for product JSON data. Adjust if yours is different!
    const productJsonScript = document.querySelector('script[type="application/json"][data-product-json], script[type="application/json"][id^="ProductJson-"]');
    if (productJsonScript) {
      const productData = JSON.parse(productJsonScript.textContent);

      // Find the variant that is currently selected (check URL first, then default)
      const urlParams = new URLSearchParams(window.location.search);
      let selectedVariantId = urlParams.get('variant');

      if (!selectedVariantId && productData.variants && productData.variants.length > 0) {
        // If no variant in URL, try finding the one marked 'selected' or use the first available one
         const selectedOption = document.querySelector('product-form input[name="id"][type="hidden"], product-form select[name="id"] option[selected]'); // Check form's hidden input or selected dropdown option
         if(selectedOption) {
            selectedVariantId = selectedOption.value;
         } else {
            // Fallback to the first variant in the JSON data
            initialVariant = productData.variants.find(v => v.available) || productData.variants[0]; // Prefer first available
            selectedVariantId = initialVariant ? String(initialVariant.id) : null;
         }
      }

      // If we have a selected ID, find the full variant object
      if (selectedVariantId && productData.variants) {
        initialVariant = productData.variants.find(v => String(v.id) === String(selectedVariantId));
      }
       console.log('Initial variant found:', initialVariant); // DEBUG Line

    } else {
        console.log('Product JSON script not found for initial variant.'); // DEBUG Line
    }
  } catch (e) {
    console.error("Error processing initial variant:", e); // DEBUG Line
  }

// Run the update function once on load with the determined initial variant's ID
console.log('DEBUG: Calling initial updateMaterialSubtitle with ID:', initialVariant ? initialVariant.id : null);
updateMaterialSubtitle(initialVariant ? String(initialVariant.id) : null); // Pass ID string or null

}); // End DOMContentLoaded